import { createNaturalDivisionTask, randInt, tensOnesSplitExplanation } from "./sharedNaturalDivision";

const candidatesByResult = (() => {
  const groups = {};
  for (let b = 2; b <= 9; b += 1) {
    for (let a = 20; a <= 99; a += 1) {
      const tens = Math.floor(a / 10) * 10;
      const ones = a % 10;
      const result = a / b;
      if (
        ones !== 0 &&
        Number.isInteger(result) &&
        result >= 10 &&
        tens % b === 0 &&
        ones % b === 0
      ) {
        if (!groups[result]) groups[result] = [];
        groups[result].push({ a, b, result });
      }
    }
  }
  return groups;
})();

const possibleResults = Object.keys(candidatesByResult)
  .map(Number)
  .filter((result) => result !== 11);

function pickData() {
  const result = possibleResults[randInt(0, possibleResults.length - 1)];
  const candidates = candidatesByResult[result];
  return candidates[randInt(0, candidates.length - 1)];
}

const mod = createNaturalDivisionTask({
  type: "NaturalDivTwoDigitTensOnesTask",
  pickData,
  explain: tensOnesSplitExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
